<div
  class="mini-actions"
  [class.visible]="visible"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave($event)"
  (click)="$event.stopPropagation()"
>
  <span
    [class.hidden]="isThreadView"
    class="mini-hit"
    (click)="onQuickReact(recentEmojis[0] || '✅')"
  >
    @if (!recentEmojis[0] || recentEmojis[0] === '✅') {
    <img src="assets/icons/check-green.svg" alt="Erledigt" class="mini-icon" />
    } @else {
    <span class="mini-emoji">{{ recentEmojis[0] }}</span>
    }
  </span>
  <span
    [class.hidden]="isThreadView"
    class="mini-hit"
    (click)="
      onQuickReact(
        recentEmojis[1] && recentEmojis[1] !== recentEmojis[0]
          ? recentEmojis[1]
          : recentEmojis[0] === '👍'
          ? '✅'
          : '👍'
      )
    "
  >
    @if ( (recentEmojis[1] && recentEmojis[1] !== recentEmojis[0] && recentEmojis[1] !== '✅') ||
    (!recentEmojis[1] && recentEmojis[0] !== '👍') ) {
    <span class="mini-emoji">{{
      recentEmojis[1] && recentEmojis[1] !== recentEmojis[0] ? recentEmojis[1] : '👍'
    }}</span>
    } @else {
    <img src="assets/icons/check-green.svg" alt="Erledigt" class="mini-icon" />
    }
  </span>
  <span class="mini-hit" (click)="onAddReactionClick($event)">
    <img src="assets/icons/add_reaction.svg" alt="Add reaction" class="mini-icon" />
  </span>
  <span [class.hidden]="isThreadView" class="mini-hit" (click)="onReplyClick($event)">
    <img src="assets/icons/comment.svg" alt="Comment" class="mini-icon" />
  </span>

  <ng-content select="[more-menu]"></ng-content>
</div>
